"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminAdd = adminAdd;
exports.adminDel = adminDel;
exports.adminInfo = adminInfo;
exports.adminList = adminList;
exports.adminUpdate = adminUpdate;
exports.controlAdminUser = controlAdminUser;
exports.getLangValueList = getLangValueList;
exports.getMenu = getMenu;
exports.menuAdd = menuAdd;
exports.menuDelete = menuDelete;
exports.menuInfo = menuInfo;
exports.menuListApi = menuListApi;
exports.menuUpdate = menuUpdate;
exports.menuUpdateShowStatus = menuUpdateShowStatus;
exports.sensitiveListApi = sensitiveListApi;
exports.updateIsSmsApi = updateIsSmsApi;
exports.updateStatusApi = updateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function getMenu() {
  return (0, _request.default)({
    url: '/admin/system/role/testMenu',
    method: 'GET'
  });
}
function adminDel(pram) {
  return (0, _request.default)({
    url: '/admin/adminUser/deleteAdminUser',
    method: 'POST',
    data: pram
  });
}
function adminInfo(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/admin/info',
    method: 'GET',
    params: data
  });
}
function adminList(params) {
  return (0, _request.default)({
    url: '/admin/adminUser/getAdminUserList',
    method: 'GET',
    params: params
  });
}
function adminAdd(pram) {
  return (0, _request.default)({
    url: '/admin/adminUser/saveAdminUser',
    method: 'POST',
    data: pram
  });
}
function adminUpdate(pram) {
  return (0, _request.default)({
    url: '/admin/system/setAffirmPassword',
    method: 'POST',
    data: pram
  });
}

/**
 * 修改状态
 * @param pram
 */
function updateStatusApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/updateStatus",
    method: 'get',
    params: params
  });
}

/**
 * 修改后台管理员是否接收状态
 * @param pram
 */
function updateIsSmsApi(params) {
  return (0, _request.default)({
    url: "/admin/system/admin/update/isSms",
    method: 'get',
    params: params
  });
}

/**
 * 权限规则菜单列表
 * @param pram
 */
function menuListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };

  return (0, _request.default)({
    url: '/admin/system/menu/getMenuList',
    method: 'get',
    params: data
  });
}
function getLangValueList(data) {
  return (0, _request.default)({
    url: '/admin/system/getLangValueList',
    method: 'get',
    params: data
  });
}

/**
 * 权限规则新增菜单
 * @param data
 */
function menuAdd(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/menu/saveMenu",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则删除菜单
 * @param data
 */
function menuDelete(data) {
  return (0, _request.default)({
    url: "/admin/system/menu/deleteMenu",
    method: 'post',
    data: data
  });
}

/**
 * 权限规则菜单详情
 * @param data
 */
function menuInfo(id) {
  return (0, _request.default)({
    url: "/admin/system/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 权限规则菜单修改
 * @param data
 */
function menuUpdate(data) {
  var systemMenuRequest = data;
  return (0, _request.default)({
    url: "/admin/system/menu/saveMenu",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param data
 */
function menuUpdateShowStatus(params) {
  return (0, _request.default)({
    url: "/admin/system/menu/updateShowStatus",
    method: 'post',
    params: params
  });
}

//
/**
 * 权限规则菜单详情
 * @param data
 */
function sensitiveListApi(params) {
  return (0, _request.default)({
    url: "/admin/log/sensitive/list",
    method: 'get',
    params: params
  });
}

/**
 * 修改用户管理状态
 * @param data
 */
function controlAdminUser(data) {
  return (0, _request.default)({
    url: "/admin/adminUser/controlAdminUser",
    method: 'post',
    data: data
  });
}